import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';
import { getBreakpoint } from 'wanderu-utils';

const sendEvent = (action, label, property) => SnowplowService.fireStructuredEvent({
    action,
    category: 'trip_refresh_modal',
    label,
    property,
});

const clickSkipEvent = ({
    direction,
    funnelStage,
    searchParams = {},
}) => {
    const {
        destinationPlaceId,
        destinationText,
        originPlaceId,
        originText,
    } = searchParams;

    sendEvent('click', 'skip');

    amplitude.track('Search Interacted', {
        arrive_address: destinationText,
        arrive_place_id: destinationPlaceId,
        breakpoint: getBreakpoint(),
        declined_method: 'skip_button',
        depart_address: originText,
        depart_place_id: originPlaceId,
        funnel_stage: funnelStage,
        interaction_type: 'pricing_refresh_declined',
        is_departing_results: direction === 'depart',
    });
};
const clickRefreshEvent = ({
    direction,
    funnelStage,
    searchParams = {},
}) => {
    const {
        destinationPlaceId,
        destinationText,
        originPlaceId,
        originText,
    } = searchParams;

    sendEvent('click', 'refresh');

    amplitude.track('Search Interacted', {
        arrive_address: destinationText,
        arrive_place_id: destinationPlaceId,
        breakpoint: getBreakpoint(),
        depart_address: originText,
        depart_place_id: originPlaceId,
        funnel_stage: funnelStage,
        interaction_type: 'pricing_refresh_accepted',
        is_departing_results: direction === 'depart',
    });
};
const clickScrimEvent = ({
    direction,
    funnelStage,
    searchParams = {},
}) => {
    const {
        destinationPlaceId,
        destinationText,
        originPlaceId,
        originText,
    } = searchParams;

    sendEvent('click', 'scrim');

    amplitude.track('Search Interacted', {
        arrive_address: destinationText,
        arrive_place_id: destinationPlaceId,
        breakpoint: getBreakpoint(),
        declined_method: 'scrim_click',
        depart_address: originText,
        depart_place_id: originPlaceId,
        funnel_stage: funnelStage,
        interaction_type: 'pricing_refresh_declined',
        is_departing_results: direction === 'depart',
    });
};
const renderModalEvent = ({
    direction,
    funnelStage,
    searchParams = {},
}) => {
    const {
        destinationPlaceId,
        destinationText,
        originPlaceId,
        originText,
    } = searchParams;

    sendEvent('rendered', direction);

    amplitude.track('Search Interacted', {
        arrive_address: destinationText,
        arrive_place_id: destinationPlaceId,
        breakpoint: getBreakpoint(),
        depart_address: originText,
        depart_place_id: originPlaceId,
        funnel_stage: funnelStage,
        interaction_type: 'pricing_refresh_offered',
        is_departing_results: direction === 'depart',
    });
};

const events = {
    clickRefreshEvent,
    clickScrimEvent,
    clickSkipEvent,
    renderModalEvent,
};

export default events;
